import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#F5F5F5] text-[#1F2937] py-10">
      <div className="max-w-4xl mx-auto px-5 bg-white rounded-2xl shadow-lg p-8">
        <h1 className="text-[#4F46E5] text-4xl font-bold mb-5 pb-3 border-b-2 border-[#E5E7EB]">Privacy Policy</h1>
        <span className="text-sm text-[#6B7280] block mb-5">Effective Date: October 22, 2025</span>

        <p className="mb-6 text-[#4B5563] leading-relaxed">
          This Privacy Policy describes how RetireProApp (operated by Sfumato Ventures) collects, uses, and discloses your information when you use our Service. We are committed to protecting your financial data and ensuring complete transparency.
        </p>

        <h2 className="text-[#4F46E5] text-2xl font-bold mt-8 mb-4">1. Company Information and Jurisdiction</h2>
        <p className="mb-4 text-[#4B5563] leading-relaxed">
          The Service is operated by <strong>Sfumato Ventures</strong> ("we," "us," or "our").
        </p>
        <p className="mb-4 text-[#4B5563] leading-relaxed">
          <strong>Address:</strong> 553, 5th Main AGS Layout, Bengaluru, Karnataka, India.
        </p>
        <p className="mb-6 text-[#4B5563] leading-relaxed">
          This policy is governed by and interpreted in accordance with the laws of <strong>India</strong>, and specifically the jurisdiction of <strong>Bengaluru, Karnataka</strong>.
        </p>

        <h2 className="text-[#4F46E5] text-2xl font-bold mt-8 mb-4">2. Data Collection and Usage</h2>
        
        <h3 className="text-[#7C3AED] text-xl font-semibold mt-6 mb-3">Personal Financial Data (Provided by You)</h3>
        <p className="mb-4 text-[#4B5563] leading-relaxed">
          We collect the financial and planning data you directly input into the Service (income, expenses, assets, debts). This data is the <strong>minimum required</strong> to generate your projections and reports.
        </p>
        <p className="mb-6 text-[#4B5563] leading-relaxed">
          We want to be perfectly clear: <strong>RetireProApp is a DIY planning tool and has no access to your private bank account details, passwords, or transaction history.</strong> All inputs are made manually by the user.
        </p>

        <h3 className="text-[#7C3AED] text-xl font-semibold mt-6 mb-3">Usage and Analytics Data (Automatically Collected)</h3>
        <p className="mb-6 text-[#4B5563] leading-relaxed">
          We collect anonymized data on how the Service is accessed and used (e.g., time spent on a feature, errors encountered). This data is used solely to improve application performance and user experience. It <strong>does not</strong> contain any personally identifiable or financial information.
        </p>
        
        <h2 className="text-[#4F46E5] text-2xl font-bold mt-8 mb-4">3. Confidentiality and Data Security Guarantee</h2>
        <p className="mb-4 text-[#4B5563] leading-relaxed">Your financial data is treated with the highest level of security and confidentiality:</p>
        <ul className="mb-6 space-y-3 text-[#4B5563] leading-relaxed">
          <li className="flex items-start gap-3">
            <span className="text-[#1F2937] font-semibold">Non-Sharing:</span>
            <span>Your financial data is <strong>never shared, sold, traded, or otherwise transferred</strong> to any third parties for marketing or any other commercial purpose.</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-[#1F2937] font-semibold">Anonymity:</span>
            <span>Your financial planning data is stored <strong>anonymously</strong> and is only linked to your account for the purpose of running simulations and calculations for <em>you</em>.</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-[#1F2937] font-semibold">Encryption:</span>
            <span>All sensitive planning data is <strong>stored in an encrypted form</strong> on secure servers and is transmitted using secure socket layer technology (SSL).</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-[#1F2937] font-semibold">Core Purpose:</span>
            <span>The data entered is used strictly for <strong>calculation, projection, and visualization</strong> purposes to provide the core functionality of the Service.</span>
          </li>
        </ul>
        
        <h2 className="text-[#4F46E5] text-2xl font-bold mt-8 mb-4">4. Your Data Protection Rights</h2>
        <p className="mb-4 text-[#4B5563] leading-relaxed">You have full control over your data, including:</p>
        <ol className="mb-6 space-y-3 text-[#4B5563] leading-relaxed">
          <li className="flex items-start gap-3">
            <span className="text-[#1F2937] font-semibold">The Right to Access:</span>
            <span>You can request copies of your personal data held by us.</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-[#1F2937] font-semibold">The Right to Rectification:</span>
            <span>You can request that we correct any information you believe is inaccurate.</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-[#1F2937] font-semibold">The Right to Erasure:</span>
            <span>You can request that we erase your personal data (full account deletion).</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-[#1F2937] font-semibold">The Right to Data Portability:</span>
            <span>You can export your entire plan to Excel or PDF format anytime.</span>
          </li>
        </ol>

        <h2 className="text-[#4F46E5] text-2xl font-bold mt-8 mb-4">5. Changes to This Privacy Policy</h2>
        <p className="mb-6 text-[#4B5563] leading-relaxed">
          We may update our Privacy Policy from time to time. We will notify you of any significant changes by posting the new Privacy Policy on this page.
        </p>

        <p className="text-[#4B5563] leading-relaxed">
          <strong>Contact Us:</strong> If you have any questions about this Privacy Policy, please contact us by email: support@retireproapp.com
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
